//@config
export default {
  home: {
    help: "v1/help/{0}",
    helpAttachments: "v1/help/{0}/attachment",
    helpAttachment: "v1/help/{0}/attachment/{1}",
    logActivities: "v1/log-activities",
    systemConfigs: "v1/system-config",
    systemConfig: "v1/system-config/{0}",
    userLoginHistory: "v1/login-history",
    formBuilders: "v1/help/form-builders",
    formBuilder: "v1/help/form-builders/{0}",
    routeFormBuilders: "v1/help/route-form-builders/{0}",
    formBuilderDeleteMenu: "v1/help/form-builders/{0}/delete-menu",
    eventManagementRules: "v1/event-management-rules",
    eventManagementRulesDetail: "v1/event-management-rules/{0}",
    eventManagementTemplates: "v1/event-management-templates",
    eventManagementTemplatesDetail: "v1/event-management-templates/{0}",
    announcements: "v1/announcements",
    announcementsDetail: "v1/announcement/{0}",
    announcementRecipients: "v1/announcement/{0}/recipients",
    myAnnouncements: "v1/my-announcements",
    myAnnouncementsVerified: "v1/my-announcements/{0}/verified",
    myAnnouncementsVerifiedAll: "v1/my-announcements-verified",
    myAnnouncementsUnread: "v1/my-announcement-unread",
    unsubscribeMessengerBot: "v1/unsubscribe-messenger-bot/{0}",
    adminLoginDeleteAllSession: "v1/admin-login-delete-all-session",
    announcementsImport: "v1/announcements-import",
  },
};
